import { ValidationErrors } from '@angular/forms';

export const wrongPasswordValidatorError: ValidationErrors = {
  wrongPassword: true,
};
